import Colors from '../../../../shared/assets/style/default/color';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DiskCapacityOuterBar = styled.div<React.CSSProperties>`
  background: ${Colors['grey']};
  position: absolute;
  width: ${800 * Screen.widthRatio}px;
  border-radius: ${49 * Screen.widthRatio}px;
  left: ${160 * Screen.widthRatio}px;
  top: ${9 * Screen.widthRatio}px;
  width: ${1525 * Screen.widthRatio}px;
  height: ${90 * Screen.widthRatio}px;
  overflow: hidden;
`;

export default DiskCapacityOuterBar;
